import { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createTokenModalOpen,
  tokenUpdate,
  updateGTMDDetail,
  updatePaymentPopup,
} from "../Pages/RoundToJoin/tocken.slice";
import axios from "axios";
import secureLogo from "../../assets/images/security-model.png";
import titleBuyTokens from "../../assets/images/buyTokenTitle.png";
import buyTokenTitleBg from "../../assets/card/buy-tokens-title-bg.svg";
import { updateLoadingStatus } from "../Pages/RoundToJoin/tocken.slice";
import { Toaster } from "react-hot-toast";
import useToastMessage from "../Utiles/Toaster";
import { baseURL } from "../services/axiosConfig";
import { refreshTokenV2 } from "../services/api";

const BuyTokenPopUp = ({ setIsOpen, component }) => {
  const { showToast, showErrorToast } = useToastMessage();
  const dispatch = useDispatch();
  const redeemPopup = useSelector((state) => state.roundToJoin.redeemPopup);
  const [tokenCount, setTokenCount] = useState(0);
  const pricePerToken = Number(process.env.REACT_APP_PRICE_PER_TOKEN);

  const tokenOptions = [
    { label: "1 Token", value: 1, price: 1 * pricePerToken },
    { label: "2 Tokens", value: 2, price: 2 * pricePerToken },
    { label: "4 Tokens", value: 4, price: 4 * pricePerToken },
    { label: "10 Tokens", value: 10, price: 10 * pricePerToken },
  ];

  const totalPrice = tokenCount * pricePerToken;

  const handleTokenCountChange = async (value) => {
    dispatch(updateLoadingStatus(true));
    const token = localStorage.getItem("access_token");
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));

    if (value >= 1) {
      setTokenCount(value);
      try {
        const res = await axios.post(
          `${baseURL}/accounts/buytokens`,
          {
            tokens: value,
            user: userInfo.userId,
          },
          {
            headers: {
              Authorization: `Bearer ${JSON.parse(token)}`,
            },
          }
        );
        if (res.data?.data?.add_token) {
          const userInfo = localStorage.getItem("userInfo");
          const userId = userInfo ? JSON.parse(userInfo).userId : null;
          window.dataLayer.push({
            'userId': userId,
            'event': 'buy_tokens_interest',
            'tokenPackId': tokenCount,
            'tokenPackValue': Number(tokenCount) * 15
          });
          const newToken = Number(res.data.data.add_token) || 0;
          dispatch(
            tokenUpdate({
              newToken,
              currency: res.data?.data?.currency_code || 'USD',
              orderId: res.data.data.order_id,
              transactionTime: res.data.data.payment_details.transaction_time,
            })
          );
          dispatch(
            tokenUpdate({
              newToken,
              currency: res.data?.data?.currency_code || 'USD',
              orderId: res.data.data.order_id,
            })
          );
          dispatch(updateLoadingStatus(false));
          dispatch(createTokenModalOpen(false));
          dispatch(updatePaymentPopup(true));
        } else {
          dispatch(updateLoadingStatus(false));
          showErrorToast("Payment gateway failed to load");
        }

        console.log("Response:", res.data);
      } catch (error) {
        if (error?.response?.status === 401) {
          refreshTokenV2(dispatch);
        }
        showErrorToast("Payment gateway failed to load");
        dispatch(updateLoadingStatus(false));
        console.error("Error fetching token details:", error);
      }
    }
  };

  const popupRef = useRef();


  useEffect(() => {
    if (component && component !== "tokenTransfer") {
      function handleClickOutside(event) {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
          dispatch(updateLoadingStatus(false));
          dispatch(createTokenModalOpen(false));
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [component]);

  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 flex justify-center items-start pt-16 sm:pt-20 md:pt-24 lg:items-center lg:pt-0 p-4"
      onClick={() => {
        dispatch(updateLoadingStatus(false));
        dispatch(createTokenModalOpen(false));
      }}
    >
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            // color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
      <div className="flex items-center justify-center w-full h-full">
        <div
          ref={popupRef}
          className="bg-white rounded-lg shadow-lg max-w-md w-full max-h-[80vh] flex flex-col overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {" "}
          <div className="relative flex justify-center">
            {/* <div
              className="bg-gradient-to-r from-[#007FFF] to-[#00C05B] w-[250px] sm:w-[300px] h-[40px] sm:h-[50px] flex items-center justify-center shadow-md text-white font-semibold text-sm sm:text-base mx-auto"
              style={{
                 clipPath: "polygon(12px -2px, 100% -12px, 89% 56%, 84% 90%, 81% 100%, 22% 100%, 18% 88%, 7% 31%, 5px 0px)",
              }}
            >
              Buy tokens
            </div> */}
            <img
              src={buyTokenTitleBg}
              alt="Buy Tokens"
              className="w-[220px] sm:w-[220px] h-auto mx-auto"
            />

            {/* Close button */}
            <button
              className="absolute top-2 right-2 md:right-6 text-[#787878] text-xl sm:text-2xl w-[20px] h-[20px] opacity-100 border-0 flex items-center justify-center"
              onClick={() => {
                dispatch(updateLoadingStatus(false));
                dispatch(createTokenModalOpen(false));
              }}
            >
              ×
            </button>
          </div>
          <div className="p-8 sm:p-6">
            <p className="text-center font-medium mb-4">
              Pick number of tokens you want to buy
            </p>

            {/* Token Buttons */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-1 sm:gap-3 mb-6">
              {tokenOptions.map((option) => (
                <button
                  key={option.value}
                  onClick={() => setTokenCount(option.value)}
                  className={`rounded-lg py-1.5 sm:py-2 text-center relative group
                    ${
                      tokenCount === option.value
                        ? "bg-white border-transparent"
                        : "border border-gray-300"
                    }
                  `}
                  style={{
                    background:
                      tokenCount === option.value
                        ? "linear-gradient(#fff, #fff) padding-box, linear-gradient(90deg, #007FFF, #00C05B) border-box"
                        : "",
                    border:
                      tokenCount === option.value
                        ? "2px solid transparent"
                        : "1px solid #D1D5DB", // fallback gray-300
                    borderRadius: "0.5rem",
                  }}
                >
                  <div
                    className={`font-semibold text-sm sm:text-base ${
                      tokenCount === option.value
                        ? "text-transparent bg-clip-text"
                        : "text-black"
                    }`}
                    style={{
                      backgroundImage:
                        tokenCount === option.value
                          ? "linear-gradient(90deg, #007FFF, #00C05B)"
                          : "none",
                      WebkitBackgroundClip:
                        tokenCount === option.value ? "text" : "initial",
                      backgroundClip:
                        tokenCount === option.value ? "text" : "initial",
                    }}
                  >
                    {option.label}
                  </div>
                  <div className="text-xs sm:text-sm text-gray-500">
                    $ {option.price}
                  </div>
                </button>
              ))}
            </div>

            {/* Or Divider */}
            <div className="flex items-center mb-1 sm:mb-4 w-[40%] mx-auto">
              <div className="flex-grow h-px bg-gray-300"></div>
              <span className="px-3 text-gray-500 text-sm">Or</span>
              <div className="flex-grow h-px bg-gray-300"></div>
            </div>

            {/* Custom Input */}
             <div 
              className="rounded-lg p-0 sm:p-6 bg-gradient-to-r"
              style={{
                background: "linear-gradient(#fff, #fff) padding-box, linear-gradient(90deg, #007FFF, #00C05B) border-box",
                border: "2px solid transparent",
                borderRadius: "0.5rem",
              }}
            >
              <div className="w-full h-full bg-white rounded-lg flex flex-col sm:flex-row gap-2 sm:gap-4 items-center justify-center p-1.5 sm:p-0">
                <label className="block text-xs sm:text-sm text-gray-600 whitespace-nowrap">
                  Enter number of tokens
                </label>
                <input
                  type="text"
                  min="1"
                  max="200" // Optional: for semantic value (won't block typing itself)
                  value={tokenCount}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      const numeric = Number(value);
                      if (numeric <= 200) {
                        setTokenCount(numeric);
                      }
                    }
                  }}
                  onKeyDown={(e) => {
                    if (
                      ["e", "E", "+", "-", "."].includes(e.key) ||
                      e.ctrlKey ||
                      e.metaKey
                    ) {
                      e.preventDefault();
                    }
                  }}
                  className="w-[80%] md:w-[50%] border border-[#007FFF4D] rounded-full px-3 sm:px-4 py-1.5 sm:py-2 text-center md:text-left font-semibold text-[#007FFF] outline-none focus:border-[#007FFF] text-sm sm:text-base"
                />
              </div>
              <p className="text-gray-500 text-xs sm:text-sm w-full text-center sm:text-center lg:text-right mt-1">
                Max 200 tokens
              </p>
            </div>

            {/* Price Display */}
            <p className="text-center font-medium mt-2 sm:mt-4 text-gray-800 mb-2 sm:mb-6">
              $ {totalPrice} for {tokenCount} token{tokenCount > 1 ? "s" : ""}
            </p>

            {/* Buy Button */}
            <div className="flex justify-center">
              <button
                className={`w-[50%] sm:w-[40%] px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg font-semibold transition-colors duration-200 text-sm sm:text-base ${
                  tokenCount >= 1
                    ? "bg-[#00C05B] text-white hover:bg-[#00a24b]"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                }`}
                onClick={() => {
                  if (tokenCount >= 1) {
                    handleTokenCountChange(tokenCount);
                    dispatch(createTokenModalOpen(false));
                  }
                }}
                disabled={tokenCount < 1}
              >
                Buy Tokens
              </button>
            </div>
            <div className="text-center text-xs text-gray-500 pb-2 mt-2">
              <span className="inline-flex items-center gap-1 whitespace-nowrap">
                Your security is more important to us{" "}
                <img
                  src={secureLogo}
                  alt="logo"
                  className="inline w-[62.57px] h-[27.23px]"
                />
              </span>
            </div>
          </div>
          {/* <div className="text-center text-xs text-gray-500 pb-4">
            Your security is more important to us{" "}
            <span className="inline-block ml-1 bg-green-100 text-green-700 px-2 py-1 rounded-full text-[10px]">
              100% SECURE ✅
            </span>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default BuyTokenPopUp;
